import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    // tslint:disable-next-line: directive-selector
    selector: 'input[numbersOnly]'
})
export class NumberOnlyDirective {

    @Input() type: string;

    constructor(private _el: ElementRef) { }

    @HostListener('input', ['$event']) onInputChange(event) {
        const initalValue = this._el.nativeElement.value;
        if (this.type === 'NoDecimal') {
            this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        } else {
            this._el.nativeElement.value = initalValue.replace(/[^0-9.]*/g, '');
        }
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        }
    }
}
